import type { LucideIcon } from 'lucide-react';

export type AppStatus = 'disponible' | 'muy-pronto' | 'en-camino';

export interface AppFeature {
  icon: LucideIcon;
  title: string;
  text: string;
}

export interface AppConnection {
  slug: AppSlug;
  text: string;
}

export type AppMedia =
  | { kind: 'phones'; items: { src: string; alt: string }[] }
  | { kind: 'browser'; src: string; alt: string; width: number; height: number };

export type AppSlug = 'mi-dashboard' | 'mi-envio-cuba' | 'mi-admin' | 'mi-cargo' | 'mi-restaurante';

export interface AppDef {
  slug: AppSlug;
  name: string;
  logo: string;
  /** One-line role, used in nav/dropdown and cross-links. */
  tagline: string;
  /** Who it is for. */
  audience: string;
  status: AppStatus;
  statusNote: string;
  seo: { title: string; description: string; keywords: string };
  hero: { eyebrow: string; headline: string; lead: string };
  /** Optional real screenshots. Never AI-rendered UI — omit until real shots exist. */
  media?: AppMedia;
  /** Optional close-up shots rendered after the features grid. */
  gallery?: { src: string; alt: string; caption: string; frame: 'browser' | 'plain'; width: number; height: number; span?: 1 | 2 }[];
  features: AppFeature[];
  /** "Cómo encaja" — how it connects to the rest of the platform. */
  connections: AppConnection[];
  faqs?: { question: string; answer: string }[];
  closer: { headline: string; text: string; primary: { label: string; to: string }; secondary?: { label: string; to: string } };
}

export const STATUS_LABEL: Record<AppStatus, string> = {
  disponible: 'Disponible',
  'muy-pronto': 'Muy pronto en App Store y Google Play',
  'en-camino': 'En camino',
};
